/* eslint-disable */
/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { CKEditor } from '@ckeditor/ckeditor5-react';
import { SectionEditor as ClassicEditorBuild } from 'ckeditor5-custom-build/build/ckeditor';
import {
  addAttachmentLink,
  CommentAttachment,
  initCkeditorCommentEvents,
  initCkeditorList,
  initContextMenu,
  initPreventCkeditorFocus,
  setCkfinderRefresh,
  setMutationObserver,
  setStickyPanel,
} from 'ckeditor5-custom-build/lib/ckeditorLib';
import { addCkfinderScriptTag, getCkfinderConnectorPath, initCkfinder } from 'ckeditor5-custom-build/lib/ckfinderLib';
import PathForImageToolbar from 'ckeditor5-custom-build/plugins/PathForImageToolbar';
import React, { Component } from 'react';
import { LICENSE_KEY } from '../../../../../constants/ckeditor';
// Localization（日本語はデフォルトで読み込まれるため、ここで読み込む必要はありません）
import 'ckeditor5-custom-build/build/translations/en';
// 今後、他の言語も読み込む場合はここで読み込んでください
import { t } from 'i18next';
import ConfirmModal from '../../../../modules/ConfirmModal';
import CommentCopyPage from '../commentCopy/CommentCopyPage';
import SectionCommentCopyWindow from '../commentCopy/SectionCommentCopyWindow';
import CommentRangePage from '../commentRange/CommentRangePage';
import SectionCommentRangeWindow from '../commentRange/SectionCommentRangeWindow';
import CommentSearchPage from '../commentSearch/CommentSearchPage';
import SectionCommentSearchWindow from '../commentSearch/SectionCommentSearchWindow';
import CommentTypePage from '../commentType/CommentTypePage';
import SectionCommentTypeWindow from '../commentType/SectionCommentTypeWindow';
import ContextMenuPage from '../contextMenu/ContextMenuPage';
import { SectionDataTree } from '../dataTree/SectionDataTree';
import SectionDataTreeWindow from '../dataTree/SectionDataTreeWindow';
import OriPage from '../ori/OriPage';
import SectionOriSearchWindow from '../ori/SectionOriSearchWindow';
import PsPage from '../ps/PsPage';
import SectionPsInfoWindow from '../ps/SectionPsInfoWindow';
import PsNotePage from '../psnote/PsNotePage';
import SectionPsNoteWindow from '../psnote/SectionPsNoteWindow';

const STORAGE_KEY = LICENSE_KEY;

export default class CKEditorAdapter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // You need this state to render the <CKEditor /> component after the layout is ready.
      // <CKEditor /> needs the HTMLElement of the `Sidebar` plugin provided through
      // the `config` property and you have to ensure that is already rendered.
      isLayoutReady: false,
      editor: null,
      licenseKey: LICENSE_KEY,
      structureTreeDialogIsOpen: false,
      psInfoDialogIsOpen: false,
      oriSearchDialogIsOpen: false,
      psNoteDialogIsOpen: false,
      commentSearchDialogIsOpen: false,
      commentTypeDialogIsOpen: false,
      commentCopyDialogIsOpen: false,
      commentRangeDialogIsOpen: false,
      selectedPsVersionId: null,
      selectedPsDerivationId: null,
      selectedLevel: null,
      threadCount: -1,
      changingCommentThreadId: '',
      referenceUpdateRun: false,
      // ContextMenu
      contextMenuDialogIsOpen: false,
      contextMenuParams: {
        selection: null,
        element: null,
      },
      contextMenuPosition: {
        x: 0,
        y: 0,
      },
    };

    this.sidebarElementRef = React.createRef();
    this.editorContainerRef = React.createRef();
    this.viewerContainerElementRef = React.createRef();
    this.viewerEditorElementRef = React.createRef();
    this.viewerSidebarContainerElementRef = React.createRef();
    this.commentSearchPageRef = React.createRef();

    // Switch between inline and sidebar annotations according to the window size.
    this.refreshDisplayMode = this.refreshDisplayMode.bind(this);
    // Prevent closing the tab when any action is pending.
    this.checkPendingActions = this.checkPendingActions.bind(this);

    this.showEditorDataInConsole = this.showEditorDataInConsole.bind(this);
    this.handlePsDerivationId = this.handlePsDerivationId.bind(this);
    this.clearPsDerivationId = this.clearPsDerivationId.bind(this);

    const editor = window.document.getElementById('ckeditor');
    editor.addEventListener('click', this.handlePsDerivationId);
    editor.addEventListener('keydown', this.handlePsDerivationId);
    window.addEventListener('resize', this.refreshDisplayMode);
    window.addEventListener('beforeunload', this.checkPendingActions);

    // CKFinder
    this.ckfinderConnectorPath = getCkfinderConnectorPath();
  }

  componentDidMount() {
    window.CKBox = ClassicEditorBuild.CKBox;
    const licenseKey = LICENSE_KEY;

    this.setState({
      // When the layout is ready, you can switch the state and render the `<CKEditor />` component.
      isLayoutReady: true,
      // Save the provided license key in the local storage.
      licenseKey,
      structureTreeDialogIsOpen: false,
      psInfoDialogIsOpen: false,
      oriSearchDialogIsOpen: false,
      psNoteDialogIsOpen: false,
      commentSearchDialogIsOpen: false,
      selectedPsVersionId: null,
      selectedPsDerivationId: null,
      selectedLevel: null,
      referenceUpdateRun: false,
    });

    window.localStorage.setItem(STORAGE_KEY, licenseKey);

    initCkfinder(this.ckfinderConnectorPath);
  }

  /**
   * 構造ツリーダイアログが表示されているかを返す。
   * @returns 表示されていればtrue、そうでなければfalse。
   */
  getStructureTreeDialogIsOpen = () => {
    return this.state.structureTreeDialogIsOpen;
  };
  /**
   * 構造ツリーダイアログの表示・非表示をセットする。
   * @param {boolean} isOpen 表示ならtrue、非表示ならfalse。
   */
  setStructureTreeDialogIsOpen = (isOpen) => {
    this.setState({ structureTreeDialogIsOpen: isOpen });
  };
  updateStructureTreeButton = (isOn) => {};
  setUpdateStructureTreeButtonFunction = (func) => {
    this.updateStructureTreeButton = func;
  };

  /**
   * PSダイアログが表示されているかを返す。
   * @returns 表示されていればtrue、そうでなければfalse。
   */
  getPsInfoDialogIsOpen = () => {
    return this.state.psInfoDialogIsOpen;
  };
  /**
   * Psダイアログの表示・非表示をセットする。
   * @param {boolean} isOpen 表示ならtrue、非表示ならfalse。
   */
  setPsInfoDialogIsOpen = (isOpen) => {
    this.setState({ psInfoDialogIsOpen: isOpen });
  };
  updatePsInfoButton = (isOn) => {};
  setUpdatePsInfoButtonFunction = (func) => {
    this.updatePsInfoButton = func;
  };

  /**
   * ORI検索ダイアログが表示されているかを返す。
   * @returns 表示されていればtrue、そうでなければfalse。
   */
  getOriSearchDialogIsOpen = () => {
    return this.state.oriSearchDialogIsOpen;
  };
  /**
   * ORI検索ダイアログの表示・非表示をセットする。
   * @param {boolean} isOpen 表示ならtrue、非表示ならfalse。
   */
  setOriSearchDialogIsOpen = (isOpen) => {
    this.setState({ oriSearchDialogIsOpen: isOpen });
  };
  updateOriSearchButton = (isOn) => {};
  setUpdateOriSearchButtonFunction = (func) => {
    this.updateOriSearchButton = func;
  };

  /**
   * PS改廃一覧ダイアログが表示されているかを返す。
   * @returns 表示されていればtrue、そうでなければfalse。
   */
  getPsNoteDialogIsOpen = () => {
    return this.state.psNoteDialogIsOpen;
  };
  /**
   * PS改廃一覧ダイアログの表示・非表示をセットする。
   * @param {boolean} isOpen 表示ならtrue、非表示ならfalse。
   */
  setPsNoteDialogIsOpen = (isOpen) => {
    this.setState({ psNoteDialogIsOpen: isOpen });
  };
  updatePsNoteButton = (isOn) => {};
  setUpdatePsNoteButtonFunction = (func) => {
    this.updatePsNoteButton = func;
  };

  // コメント検索
  // this.commentSearchPageRef = React.createRef(); が必要
  getCommentSearchDialogIsOpen = () => {
    return this.state.commentSearchDialogIsOpen;
  };
  setCommentSearchDialogIsOpen = (isOpen) => {
    this.setState({ commentSearchDialogIsOpen: isOpen });
    if (isOpen === false) {
      this.commentSearchPageRef.current.handleSearchClear();
    }
  };
  updateCommentSearchButton = (isOn) => {};
  setUpdateCommentSearchButtonFunction = (func) => {
    this.updateCommentSearchButton = func;
  };

  // コメント操作共通
  setChangingCommentThreadId = (threadId) => {
    this.setState({ changingCommentThreadId: threadId });
  };
  // コメント区分変更
  getCommentTypeDialogIsOpen = () => {
    return this.state.commentTypeDialogIsOpen;
  };
  setCommentTypeDialogIsOpen = (isOpen) => {
    this.setState({ commentTypeDialogIsOpen: isOpen });
  };
  setChangingCommentThreadId = (threadId) => {
    this.setState({ changingCommentThreadId: threadId });
  };
  handleCommentThreadWindowCancel = () => {
    this.setCommentTypeDialogIsOpen(false);
  };
  // コメントコピー
  setCommentCopyDialogIsOpen = (isOpen) => {
    this.setState({ commentCopyDialogIsOpen: isOpen });
  };
  handleCommentCopyWindowCancel = () => {
    this.setCommentCopyDialogIsOpen(false);
  };
  // コメントの範囲変更
  setCommentRangeDialogIsOpen = (isOpen) => {
    this.setState({ commentRangeDialogIsOpen: isOpen });
  };
  handleCommentRangeWindowCancel = () => {
    this.setCommentRangeDialogIsOpen(false);
  };

  // リンク更新処理
  setReferenceUpdateRun = (isRun) => {
    this.setState({ referenceUpdateRun: isRun });
  };

  // ZENTEKI PS No
  setZentekiPsNos = (psNos) => {
    this.setState({ zentekiPsNos: psNos });
  };

  /**
   * api処理中
   */
  setApiProcessing = (apiProcessing) => {
    this.props.setSecReading(apiProcessing);
  };

  componentWillUnmount() {
    this.clearPsDerivationId();
    // window.removeEventListener('click', this.handlePsDerivationId);
    // window.removeEventListener('keydown', this.handlePsDerivationId);
    window.removeEventListener('resize', this.refreshDisplayMode);
    window.removeEventListener('beforeunload', this.checkPendingActions);
  }

  render() {
    if (this.state.editor) {
      // コメントに添付ファイルが追加された場合
      if (this.props.data.argThreadId) {
        const threadId = this.props.data.argThreadId;
        const commentId = this.props.data.argCommentId;
        const url = this.props.data.argCommentURL;
        const fileName = this.props.data.argFileName;
        const commentsRepository = this.state.editor.plugins.get('CommentsRepository');
        const commentThread = commentsRepository.getCommentThread(threadId);
        if (commentThread) {
          const comment = commentThread.getComment(commentId);
          if (comment) {
            const commentAttachment = new CommentAttachment();
            commentAttachment.setComment(comment);
            commentAttachment.addDownloadItem(url, fileName);
            addAttachmentLink(commentAttachment);
          }
        }

        this.props.data.argThreadId = '';
      }
    }
    return (
      <div className="App">
        {this.state.editor && this.state.structureTreeDialogIsOpen && (
          <SectionDataTreeWindow
            onClose={() => {
              this.setStructureTreeDialogIsOpen(false);
              this.updateStructureTreeButton(false);
            }}
            headerContents={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                {this.state.editor.i18n.t('構造ツリー')}
              </div>
            }
          >
            <SectionDataTree editor={this.state.editor} sectionId={this.props.section.section_id} />
          </SectionDataTreeWindow>
        )}
        {this.state.editor && this.state.psInfoDialogIsOpen && (
          <SectionPsInfoWindow
            onClose={() => {
              this.setPsInfoDialogIsOpen(false);
              this.updatePsInfoButton(false);
            }}
            headerContents={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                {this.state.editor.i18n.t('PS情報')}
              </div>
            }
          >
            <PsPage
              editor={this.state.editor}
              psVersionId={this.state.selectedPsVersionId}
              productionId={this.props.productionId}
              psDerivationId={this.state.selectedPsDerivationId}
              level={this.state.selectedLevel}
              zentekiPsNos={this.state.zentekiPsNos}
              setZentekiPsNos={this.setZentekiPsNos}
              runZentekiAttr={this.runZentekiAttr}
            />
          </SectionPsInfoWindow>
        )}
        {this.state.editor && this.state.oriSearchDialogIsOpen && (
          <SectionOriSearchWindow
            onClose={() => {
              this.setOriSearchDialogIsOpen(false);
              this.updateOriSearchButton(false);
            }}
            headerContents={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                {this.state.editor.i18n.t('原稿検索')}
              </div>
            }
          >
            <OriPage editor={this.state.editor} productionId={this.props.productionId} />
          </SectionOriSearchWindow>
        )}
        {this.state.editor && this.state.psNoteDialogIsOpen && (
          <SectionPsNoteWindow
            onClose={() => {
              this.setPsNoteDialogIsOpen(false);
              this.updatePsNoteButton(false);
            }}
            headerContents={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                {this.state.editor.i18n.t('PS改廃案メモ一覧')}
              </div>
            }
          >
            <PsNotePage
              productionId={this.props.productionId}
              psNotes={this.props.psNotes}
              selectedCharterNumberId={this.props.selectedCharterNumberId}
              setSelectedCharterNumberId={this.props.setSelectedCharterNumberId}
            />
          </SectionPsNoteWindow>
        )}
        {this.state.editor && this.state.commentSearchDialogIsOpen && (
          <SectionCommentSearchWindow
            onClose={() => {
              this.setCommentSearchDialogIsOpen(false);
              this.updateCommentSearchButton(false);
            }}
            headerContents={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                {this.state.editor.i18n.t('コメント検索')}
              </div>
            }
          >
            <CommentSearchPage ref={this.commentSearchPageRef} editor={this.state.editor} />
          </SectionCommentSearchWindow>
        )}

        {/* コメント区分変更 */}
        {this.state.editor && this.state.commentTypeDialogIsOpen && (
          <SectionCommentTypeWindow
            onClose={() => {
              this.setCommentTypeDialogIsOpen(false);
            }}
            headerContents={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                {this.state.editor.i18n.t('区分変更')}
              </div>
            }
          >
            <CommentTypePage
              editor={this.state.editor}
              productionId={this.props.productionId}
              sectionId={this.props.section.section_id}
              threadId={this.state.changingCommentThreadId}
              setCommentTypeDialogIsOpen={this.setCommentTypeDialogIsOpen}
              onCancel={this.handleCommentThreadWindowCancel}
            />
          </SectionCommentTypeWindow>
        )}

        {/* コメントコピー */}
        {this.state.editor && this.state.commentCopyDialogIsOpen && (
          <SectionCommentCopyWindow
            onClose={() => {
              this.setCommentCopyDialogIsOpen(false);
            }}
            headerContents={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                {this.state.editor.i18n.t('コメントのコピー')}
              </div>
            }
          >
            <CommentCopyPage
              editor={this.state.editor}
              productionId={this.props.productionId}
              sectionId={this.props.section.section_id}
              threadId={this.state.changingCommentThreadId}
              setCommentCopyDialogIsOpen={this.setCommentCopyDialogIsOpen}
              onCancel={this.handleCommentCopyWindowCancel}
            />
          </SectionCommentCopyWindow>
        )}

        {/* コメントの範囲変更 */}
        {this.state.editor && this.state.commentRangeDialogIsOpen && (
          <SectionCommentRangeWindow
            onClose={() => {
              this.setCommentRangeDialogIsOpen(false);
            }}
            headerContents={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                {this.state.editor.i18n.t('範囲変更')}
              </div>
            }
          >
            <CommentRangePage
              editor={this.state.editor}
              productionId={this.props.productionId}
              sectionId={this.props.section.section_id}
              threadId={this.state.changingCommentThreadId}
              setCommentRangeDialogIsOpen={this.setCommentRangeDialogIsOpen}
              onCancel={this.handleCommentRangeWindowCancel}
            />
          </SectionCommentRangeWindow>
        )}

        {/* リファレンス更新 */}
        {this.state.editor && this.state.referenceUpdateRun && (
          <ConfirmModal
            onClickOk={() => {
              this.setReferenceUpdateRun(false);

              refernceUpdater.onReferenceUpdate(
                this.state.editor,
                this.props.productionId,
                process.env.REACT_APP_API_BASE_PATH,
                this.props.section.section_id,
                this.setApiProcessing
              );
            }}
            onClickCancel={() => this.setReferenceUpdateRun(false)}
          >
            {this.state.editor.i18n.t('リンク情報を更新しますか?')}
          </ConfirmModal>
        )}

        {/* 右クリックメニュー */}
        {this.state.editor && this.state.contextMenuDialogIsOpen && (
          <ContextMenuPage
            contentType="section"
            editor={this.state.editor}
            params={this.state.contextMenuParams}
            defaultPosition={this.state.contextMenuPosition}
            onClose={() => {
              this.setState({ contextMenuDialogIsOpen: false });
            }}
          />
        )}

        <main>
          <div className="centered">{this.renderEditor()}</div>
        </main>
      </div>
    );
  }

  renderEditor() {
    return (
      <div className="row row-editor">
        <div className="editors-holder">
          <div className="editor-container" id="editor-container" ref={this.editorContainerRef}>
            {/* Do not render the <CKEditor /> component before the layout is ready. */}
            {this.state.isLayoutReady && (
              <CKEditor
                onReady={(editor) => {
                  editor.focus;
                  this.setState({ editor });
                  this.props.setEditor(editor);

                  window.editor = editor; // リストで使うのでマスト
                  this.refreshDisplayMode();
                  this.setCommentReadOnly(editor);
                  addCkfinderScriptTag();
                  setStickyPanel(editor);
                  setMutationObserver(editor);
                  setCkfinderRefresh();
                  initCkeditorList(editor);
                  initCkeditorCommentEvents(editor);
                  initPreventCkeditorFocus();
                  this.setTableLayout(); // ストライプテーブルのレイアウト

                  this.setZentekiPsNos(this.props.section.zenteki_psnos);
                  this.setZentekiAttr(this.props.section.zenteki_psnos);

                  // 読込み完了
                  this.props.setSecReading(false);

                  // 右クリック
                  initContextMenu(editor, (result) => {
                    const { selection, element, mousePosition } = result;
                    this.setState({
                      contextMenuDialogIsOpen: true,
                      contextMenuParams: { selection, element },
                      contextMenuPosition: mousePosition,
                    });
                  });
                }}
                onBlur={(event, editor) => {
                  this.props.setEditor(editor);
                }}
                editor={ClassicEditorBuild}
                config={{
                  extraPlugins: [
                    UsersIntegration,
                    CommentsIntegration,
                    // TrackChangesIntegration,
                    RevisionHistoryIntegration,
                    PathForImageToolbar,
                    listenChangeLink, // ← リファレンスコメントアウト
                  ],
                  customValues: {
                    commentThreads: this.props.section.comment_thread_json
                      ? JSON.parse(this.props.section.comment_thread_json)
                      : [],
                    revisionThreads: this.props.section.revision_json
                      ? JSON.parse(this.props.section.revision_json)
                      : [],
                    suggestionThreads: this.props.section.edit_content.track_threads_json
                      ? JSON.parse(this.props.section.edit_content.track_threads_json)
                      : [],
                    users: this.props.section.user_json ? JSON.parse(this.props.section.user_json) : [],
                    user: this.props.user,
                    isOwnProduction: !this.props.isReadOnly,
                  },
                  sidebar: {
                    container: this.sidebarElementRef.current,
                  },
                  ckfinder: {
                    options: {
                      rememberLastFolder: false,
                      startupPath: 'production:illust', // 初期表示ディレクトリの指定（resourceType名:フォルダへの相対パス）
                      connectorPath: this.ckfinderConnectorPath, // Laravel 側の connector エンドポイント
                      connectorInfo:
                        'mode=production&product_id=' + this.props.productionId + '&user_id=' + this.props.user.user_id, // connector へ追加する独自パラメータ
                      resourceType: '', // ここを設定しないと type（resourceType）が自動で「contents」にされてしまうため、空白でも必要。もしく特定のリソースタイプを明示する
                      productionId: this.props.productionId,
                      apiBasePath: process.env.REACT_APP_API_BASE_PATH,
                      messages: {
                        deleteFolderConfirm: t('削除を確認するため「削除」と入力してください。'),
                        deleteFolderKey: t('削除'),
                      },
                      plugins: 'MyPlugin',
                    },
                  },
                  licenseKey: LICENSE_KEY,
                  revisionHistory: {
                    editorContainer: this.editorContainerRef.current,
                    viewerContainer: this.viewerContainerElementRef.current,
                    viewerEditorElement: this.viewerEditorElementRef.current,
                    viewerSidebarContainer: this.viewerSidebarContainerElementRef.current,
                  },
                  autosave: {
                    save: (editor) => {
                      const revisionTracker = editor.plugins.get('RevisionTracker');
                      return revisionTracker.update();
                    },
                  },
                  structureTree: {
                    getIsOpen: this.getStructureTreeDialogIsOpen,
                    setIsOpen: this.setStructureTreeDialogIsOpen,
                    setUpdateButtonFunction: this.setUpdateStructureTreeButtonFunction,
                  },
                  psinfo: {
                    getIsOpen: this.getPsInfoDialogIsOpen,
                    setIsOpen: this.setPsInfoDialogIsOpen,
                    setUpdateButtonFunction: this.setUpdatePsInfoButtonFunction,
                    setIsEnabled: true, // !this.props.isReadOnly,
                  },
                  orisearch: {
                    getIsOpen: this.getOriSearchDialogIsOpen,
                    setIsOpen: this.setOriSearchDialogIsOpen,
                    setUpdateButtonFunction: this.setUpdateOriSearchButtonFunction,
                    setIsEnabled: true, // !this.props.isReadOnly,
                  },
                  psnote: {
                    getIsOpen: this.getPsNoteDialogIsOpen,
                    setIsOpen: this.setPsNoteDialogIsOpen,
                    setUpdateButtonFunction: this.setUpdatePsNoteButtonFunction,
                    setIsEnabled: true, // !this.props.isReadOnly,
                  },
                  commentSearch: {
                    getIsOpen: this.getCommentSearchDialogIsOpen,
                    setIsOpen: this.setCommentSearchDialogIsOpen,
                    setUpdateButtonFunction: this.setUpdateCommentSearchButtonFunction,
                    setIsEnabled: true,
                  },
                  comments: {
                    editorConfig: {
                      // コメント区分
                      getIsDialogOpen: this.getCommentTypeDialogIsOpen,
                      setIsDialogOpen: this.setCommentTypeDialogIsOpen,
                      // コメントコピー
                      setIsCommentCopyDialogIsOpen: this.setCommentCopyDialogIsOpen,
                      // コメントの範囲変更
                      setIsCommentRangeDialogOpen: this.setCommentRangeDialogIsOpen,
                      // Others
                      setChangingCommentThreadId: this.setChangingCommentThreadId,
                      disabled: this.props.isReadOnly,
                    },
                  },
                  reference: {
                    // リンク処理用config
                    productionId: this.props.productionId,
                    sectionId: this.props.section.section_id,
                    apiBasePath: process.env.REACT_APP_API_BASE_PATH,
                    setApiProcessing: this.setApiProcessing,
                  },
                  referenceUpdate: {
                    setIsRun: this.setReferenceUpdateRun,
                    isEnabled: true, // リンク更新ボタンをOFF
                  },
                  decisionText: {
                    // テキスト確定
                    runPlugin: this.runZentekiAttr,
                  },
                }}
                data={this.props.section.edit_content.xml_content}
                // data={AppData.initialData}
                disabled={this.props.isReadOnly}
                // disabled={true}
              />
            )}
            <div ref={this.sidebarElementRef} className="sidebar" />
          </div>
          <div ref={this.viewerContainerElementRef}>
            <div className="editor-container">
              <div ref={this.viewerEditorElementRef} />
              <div className="sidebar-container" ref={this.viewerSidebarContainerElementRef} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  /**
   * タグを遡って検索
   * @param エレメント element
   * @param 取得したい属性名 keyword
   * @returns
   */
  search = function (element, keyword) {
    for (const [key, attr] of element._attrs) {
      if (attr.attributes && attr.attributes[keyword]) {
        return [element, key];
      } else {
      }
    }
    if (!element.parent) return [null, null];
    return this.search(element.parent, keyword);
  };

  /**
   * カーソル位置のレベルを取得
   * @param エレメント element
   * @returns
   */
  searchLevel = function (element) {
    if (
      element.name === 'l2Text' ||
      element.name === 'l3Text' ||
      element.name === 'l4Text' ||
      element.name === 'l5Text'
    ) {
      for (const [key, value] of element._attrs) {
        if (key === 'class') {
          return value;
        }
      }
    }
    if (!element.parent) return null;
    return this.searchLevel(element.parent);
  };

  clearPsDerivationId() {
    this.props.setPsDerivationId(null);
  }

  /**
   * カーソル位置のidを取得
   * @param イベントハンドラ e
   * @returns
   */
  handlePsDerivationId(e) {
    if (!this.state?.editor) {
      return;
    }

    if (e.key && !['ArrowUp', 'ArrowDown', 'ArrowRight', 'ArrowLeft'].includes(e.key)) return;

    const editor = this.state.editor;
    const selection = editor.model.document.selection;
    const blocks = [...selection.getSelectedBlocks()];

    // 現在選択中のタグを確認
    var psDerivationId = null;
    var psVersionId = undefined;
    var level = null;
    if (blocks[0]) {
      const [selectElement, attrName] = this.search(blocks[0], 'ps_derivation_id');
      if (selectElement) {
        psDerivationId = selectElement.getAttribute(attrName).attributes.ps_derivation_id;
        psVersionId = selectElement.getAttribute(attrName).attributes.ps_version_id;
      }

      // レベル取得
      level = this.searchLevel(blocks[0]);
    }
    this.props.setPsDerivationId(psDerivationId);
    this.setState({ selectedPsVersionId: psVersionId });
    this.setState({ selectedPsDerivationId: psDerivationId });
    this.setState({ selectedLevel: level });
  }
  refreshDisplayMode() {
    if (!this.state.editor) {
      return;
    }

    const annotationsUIs = this.state.editor.plugins.get('AnnotationsUIs');
    const sidebarElement = this.sidebarElementRef.current;

    if (window.innerWidth < 1070) {
      sidebarElement.classList.remove('narrow');
      sidebarElement.classList.add('hidden');
      annotationsUIs.switchTo('inline');
    } else if (window.innerWidth < 1300) {
      sidebarElement.classList.remove('hidden');
      sidebarElement.classList.add('narrow');
      annotationsUIs.switchTo('narrowSidebar');
    } else {
      sidebarElement.classList.remove('hidden', 'narrow');
      annotationsUIs.switchTo('wideSidebar');
    }
  }

  setCommentReadOnly(editor) {
    // set ReadOnly
    if (!editor) {
      return;
    }

    const commentsRepositoryPlugin = editor.plugins.get('CommentsRepository');
    editor.config._config.customValues.commentThreads.forEach((element) => {
      //      let thread = commentsRepositoryPlugin.getCommentThread(element.threadId);
      let divThread = document.querySelector('div[data-thread-id="' + element.threadId + '"]');
      if (divThread) {
        divThread.setAttribute('isComplete', element.isComplete);
      }
    });
  }

  showEditorDataInConsole(evt) {
    const editorData = this.state.editor.data.get();

    const revisionsRepositoryPlugin = this.state.editor.plugins.get('RevisionsRepository');
    // const trackChanges = this.state.editor.plugins.get('TrackChanges');
    const comments = this.state.editor.plugins.get('CommentsRepository');

    const revisionsData = revisionsRepositoryPlugin.getRevisions();
    // const suggestionsData = trackChanges.getSuggestions();
    const commentThreadsData = comments.getCommentThreads({
      skipNotAttached: true,
      skipEmpty: true,
    });

    evt.preventDefault();
  }

  checkPendingActions(domEvt) {
    if (!this.state.editor) {
      return;
    }

    if (this.state.editor.plugins.get('PendingActions').hasAny) {
      domEvt.preventDefault();
      domEvt.returnValue = true;
    }
  }

  /**
   * ストライプテーブルのレイアウト
   */
  setTableLayout() {
    for (let tidx = 0; tidx < 2; tidx++) {
      // tableインデックス
      let style_value;
      if (tidx == 0) {
        style_value = 'border-style:strip;';
      } else {
        style_value = 'border-style:stripborder;';
      }

      let tableCount = 1;
      document.querySelectorAll('table[style="' + style_value + '"]').forEach((stripTables) => {
        // 最大列数取得
        let maxcol = 0;
        // ヘッダー
        stripTables.querySelectorAll('table[style="' + style_value + '"] > thead > tr').forEach((trElement) => {
          let ths = trElement.querySelectorAll('th');
          if (maxcol < ths.length) {
            maxcol = ths.length;
          }
        });
        // ボディー
        stripTables.querySelectorAll('table[style="' + style_value + '"] > tbody > tr').forEach((trElement) => {
          let tds = trElement.querySelectorAll('td');
          if (maxcol < tds.length) {
            maxcol = tds.length;
          }
        });

        // 背景色を付ける行を設定
        let nuri = false;
        let nurirow = [];
        let idx = 0;
        stripTables.querySelectorAll('table[style="' + style_value + '"] tr').forEach((trElement, key) => {
          if (key > 0) {
            let ths = trElement.querySelectorAll('th');
            let tds = trElement.querySelectorAll('td');
            let collength = 0;
            if (ths.length > 0) {
              ths.forEach((th) => {
                if (th.hasAttribute('colspan')) {
                  collength = collength + Number(th.getAttribute('colspan'));
                } else {
                  collength++;
                }
              });
            } else {
              tds.forEach((td) => {
                if (td.hasAttribute('colspan')) {
                  collength = collength + Number(td.getAttribute('colspan'));
                } else {
                  collength++;
                }
              });
            }

            if (maxcol <= collength) {
              nuri = !nuri;
            }
            if (nuri) {
              nurirow[idx] = key;
              idx++;
            }
          }
        });

        // 背景色をセット
        stripTables.querySelectorAll('table[style="' + style_value + '"] tr').forEach((trElement, key) => {
          if (nurirow.includes(key)) {
            trElement.querySelectorAll('td').forEach((tdElement) => {
              tdElement.style.backgroundColor = '#d1d2d4';
            });
            trElement.querySelectorAll('th').forEach((thElement) => {
              thElement.style.backgroundColor = '#d1d2d4';
            });
          } else {
            trElement.querySelectorAll('td').forEach((tdElement) => {
              tdElement.style.backgroundColor = 'transparent';
            });
            trElement.querySelectorAll('th').forEach((thElement) => {
              thElement.style.backgroundColor = 'transparent';
            });
          }
        });

        tableCount++;
      });
    }
  }

  /**
   * ZENTEKIのPSに属性値を付与する
   */
  setZentekiAttr(zentekiPsNos) {
    // nullなら処理を抜ける
    if (!zentekiPsNos) return;

    // 読込み時のzenteki
    document.querySelectorAll(`[ps_no]`).forEach((element) => {
      const ps_no = element.getAttribute('ps_no');
      if (zentekiPsNos.includes(ps_no)) {
        element.setAttribute('zenteki', 'on');
      }
    });
  }

  // テキスト確定が行われた
  runZentekiAttr = () => {
    // zenteki再表示
    this.setZentekiAttr(this.state.zentekiPsNos);
  };
}

class UsersIntegration {
  constructor(editor) {
    this.editor = editor;
  }

  init() {
    const usersPlugin = this.editor.plugins.get('Users');

    // Load the users data.
    // for (const user of AppData.users) {
    for (const user of this.editor.config._config.customValues.users) {
      usersPlugin.addUser(user);
    }

    // Set the current user.
    // usersPlugin.defineMe(AppData.defineMe);
    usersPlugin.defineMe(String(this.editor.config._config.customValues.user.user_id));
  }
}

class CommentsIntegration {
  constructor(editor) {
    this.editor = editor;
  }

  init() {
    const commentsRepositoryPlugin = this.editor.plugins.get('CommentsRepository');

    // Load the comment threads data.
    // for (const commentThread of AppData.commentThreads) {
    for (const commentThread of this.editor.config._config.customValues.commentThreads) {
      commentsRepositoryPlugin.addCommentThread(commentThread);
    }
  }
}

// class TrackChangesIntegration {
//   constructor(editor) {
//     this.editor = editor;
//   }

//   init() {
//     const trackChangesPlugin = this.editor.plugins.get('TrackChanges');

//     // Load the suggestions data.
//     for (const suggestion of this.editor.config._config.customValues.suggestionThreads) {
//       // for (const suggestion of AppData.trackThreads) {
//       trackChangesPlugin.addSuggestion(suggestion);
//     }
//   }
// }

class RevisionHistoryIntegration {
  constructor(editor) {
    this.editor = editor;
  }

  static get requires() {
    return ['RevisionHistory'];
  }

  init() {
    const revisionHistory = this.editor.plugins.get('RevisionHistory');

    // Load revisions data
    for (const revisionData of this.editor.config._config.customValues.revisionThreads) {
      // for (const revisionData of AppData.revisionHistory) {
      revisionHistory.addRevisionData(revisionData);
    }
  }
}

/**
 * リンク更新クラス
 *     コメントが消える
 *     aに割り当てられているスタイルが消える
 */
class refernceUpdater {
  /**
   * ユーザーがリンクボタンからIDを入力した後の処理
   * @param {*} editor
   * @returns
   */
  static onReferenceUpdateOnce = (editor) => {
    if (!editor) {
      return;
    }

    // リンク設定
    const referenceConfig = editor.config.get('reference');
    const productionId = referenceConfig.productionId; // 資料管理ID
    const sectionId = referenceConfig.sectionId; // L2セクションID
    const apiBasePath = referenceConfig.apiBasePath; // Apiベースパス
    const setApiProcessing = referenceConfig.setApiProcessing; // api処理中フラグ

    // 現在選択しているp要素を取得
    const selection = editor.model.document.selection;
    const blocks = [...selection.getSelectedBlocks()];
    const pElement = blocks[0];
    if (pElement == null) return;

    // a要素を含むp要素配列（ユーザー操作の場合、要素は1つのみ）
    let taElements = [];
    /*
    console.log('-----------------------------------------------');
    console.log(pElement);
    console.log('-----------------------------------------------');
    */
    // a要素の情報を取得
    const aInfoArr = this._getAInfo(pElement);
    if (aInfoArr.length == 0) return;
    // console.log(aInfoArr);

    // a要素ありの場合、情報を配列に入れる
    let item = {
      element: pElement, // p要素
      ainfo: aInfoArr, // p要素内のリンク情報配列
    };
    // 配列に格納
    taElements.push(item);

    // 非同期通信
    const apiKey = this._getApiKey(); // apiキー
    const apiTopUrl = this._getApiTopUrl(apiBasePath);
    const apiUrl = `${apiTopUrl}/sections/${sectionId}/reference`; // apiのURL

    // apiパラメータ―作成
    const params = [];
    taElements.forEach((taElement, index) => {
      for (var aInfo of taElement.ainfo) {
        const item = {
          production_id: productionId,
          a_id: aInfo.a_id,
          reference_id: aInfo.reference_id,
          index: index, // 戻ってくるリンクxmlを親であるPタグと結びつけるためのインデックス
        };
        params.push(item);
      }
    });

    // api処理中
    setApiProcessing(true);

    // Fetch APIはブラウザに搭載された非同期処理をするための関数です
    fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-API-KEY': apiKey },
      body: JSON.stringify({ reference_data: params }),
    })
      .then((response) => response.json()) // 返ってきたレスポンスをjsonで受け取って次のthenへ渡す
      .then((res) => {
        // 成功
        // リンクを持つPタグ毎に処理する
        this._setLinkModel(editor, res, taElements);
      })
      .catch((error) => console.error('Failed to notify.', error))
      .finally(() => {
        // api処理終了
        setApiProcessing(false);
      });
  };

  /**
   * リンクの一括更新
   * @param {*} editor
   * @param {*} productionId
   * @param {*} apiBasePath
   * @param {*} sectionId
   * @param {*} setApiProcessing
   * @returns
   */
  static onReferenceUpdate = (editor, productionId, apiBasePath, sectionId, setApiProcessing) => {
    if (!editor) {
      return;
    }

    /*
    // マーカー確認テスト
    const markers = editor.model.markers;
    const markersMap = editor.utils.toMap(markers._markers);
    for (const [key, val] of markersMap) {
      // console.log(key);
      // console.log(val.getRange());
      // console.log(val.getStart().path);
      // console.log(val.getEnd().path);
      // console.log(val.getData());
    }
    */

    // a要素を含むp要素
    let taElements = [];

    // L2内のリンク情報を取得しtaElementsに格納
    const rootEl = editor.model.document.getRoot();
    rootEl._children._nodes.forEach((element) => {
      this._getPAElement(element, taElements);
    });

    // 非同期通信
    const apiKey = this._getApiKey(); // apiキー
    const apiTopUrl = this._getApiTopUrl(apiBasePath);
    const apiUrl = `${apiTopUrl}/sections/${sectionId}/reference`; // apiのURL
    // パラメータ―作成
    const params = [];
    taElements.forEach((taElement, index) => {
      for (var aInfo of taElement.ainfo) {
        const item = {
          production_id: productionId,
          a_id: aInfo.a_id,
          reference_id: aInfo.reference_id,
          index: index, // 戻ってくるリンクxmlを親であるPタグと結びつけるためのインデックス
        };
        params.push(item);
      }
    });

    // api処理中
    setApiProcessing(true);

    // Fetch APIはブラウザに搭載された非同期処理をするための関数です
    fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-API-KEY': apiKey },
      body: JSON.stringify({ reference_data: params }),
    })
      .then((response) => response.json()) // 返ってきたレスポンスをjsonで受け取って次のthenへ渡す
      .then((res) => {
        // console.log(res);
        // 成功
        this._setLinkModel(editor, res, taElements);
      })
      .catch((error) => {
        console.error('Failed to notify.', error);
      })
      .finally(() => {
        // api処理終了
        setApiProcessing(false);
      });
  };

  // apiからのリンクXMLでa要素を置き換える
  static _setLinkModel = (editor, res, taElements) => {
    editor.model.change((writer) => {
      for (var i = 0; i < taElements.length; i++) {
        const pElement = taElements[i].element;
        const ainfo = taElements[i].ainfo;
        // console.log(ainfo);

        // リンクのxml配列を回し、該当のxmlを見つけて入れ替える
        for (const item of res.reference_xml) {
          // インデックスが一致するもの
          if (item[0] == i) {
            const xml = item[1];

            let ainfoIdx = null; // p要素内に複数のa要素がある場合、hrefによって該当のa要素配列を取得するためのindex

            // xmlをmodelに変換
            const viewFragment = editor.data.processor.toView(xml);
            const modelFragment = editor.data.toModel(viewFragment);

            // modelFragment ⇒ modelに変換(複数の可能性)
            const textInfo = this._getTextNode(modelFragment);

            // Pタグ内の該当のAタグを見つけて入れ替える
            let rmTexts = [];
            let insertPosition = null;
            pElement._children._nodes.forEach((aElement) => {
              if (aElement.hasAttribute('linkHref')) {
                const linkHref = String(aElement.getAttribute('linkHref'));
                if (textInfo.href == linkHref) {
                  // href属性値が一致したものを置き換える
                  if (rmTexts.length == 0) {
                    writer.setSelection(aElement, 'before');
                    insertPosition = editor.model.document.selection.getFirstPosition();
                  }
                  // console.log(aElement);
                  rmTexts.push(aElement);

                  // リンク情報配列のindexを取得
                  ainfo.forEach((item, index) => {
                    if (item.reference_id == linkHref) {
                      ainfoIdx = index;
                    }
                  });
                }
              }
            });

            // 置き換えるものが存在する
            if (rmTexts.length > 0) {
              // リンク要素を削除
              for (const rmText of rmTexts) {
                writer.remove(rmText);
              }

              // 新しいものに置き換え(textが複数ある場合、逆の順で挿入する)
              //   既存のtext(a要素)の先頭から前方向に置き換えるa要素を挿入
              const reversed = textInfo.texts.reverse();
              for (const text of reversed) {
                writer.insert(text, insertPosition);
              }

              if (ainfoIdx != null) {
                // コメント情報
                const cInfo = ainfo[ainfoIdx].c_info;

                // コメントのパターンによってマーカーのレンジを操作する必要がある
                console.log('コメントパターン：' + cInfo.pattern.toString());
                if (cInfo.pattern != 0 && cInfo.pattern != 3) {
                  let startPosition;
                  let endPosition;

                  // textを全て挿入した時点でのpositionを取得する
                  // textを挿入した時点で既存のコメントマーカーも変わる可能性もあるので、MarkersをここでKeyから取得して、Positionを取る
                  const cmMarkers = editor.model.markers;
                  const cmMarker = cmMarkers.get(cInfo.cmKey);
                  const cmStartPosition = cmMarker.getStart();
                  const cmEndPosition = cmMarker.getEnd();

                  // マーカーのパターンによってレンジを設置する
                  const lastText = reversed[0];
                  const firstText = reversed[reversed.length - 1];

                  if (cInfo.pattern == 1) {
                    startPosition = writer.createPositionBefore(firstText);
                    endPosition = writer.createPositionAfter(lastText);
                  } else if (cInfo.pattern == 2) {
                    // 内側　--->  この場合はa要素全てにマーカーを付けることにする
                    startPosition = writer.createPositionBefore(firstText);
                    endPosition = writer.createPositionAfter(lastText);
                  } else if (cInfo.pattern == 4) {
                    // 前が同じ、後ろは外
                    startPosition = writer.createPositionBefore(firstText);
                    endPosition = cmEndPosition;
                  } else if (cInfo.pattern == 5) {
                    // 前が同じ、後ろは中　--->  この場合はマーカーの後ろはa要素の後ろに合わせることにする
                    startPosition = writer.createPositionBefore(firstText);
                    endPosition = writer.createPositionAfter(lastText);
                  } else if (cInfo.pattern == 6) {
                    // 後ろが同じ、前は外
                    startPosition = cmStartPosition;
                    endPosition = writer.createPositionAfter(lastText);
                  } else if (cInfo.pattern == 7) {
                    // 後ろが同じ、前は中　--->  この場合はマーカーの先頭はa要素の先頭に合わせることにする
                    startPosition = writer.createPositionBefore(firstText);
                    endPosition = writer.createPositionAfter(lastText);
                  } else if (cInfo.pattern == 8) {
                    // 前から途中まで　--->  この場合はマーカーの後ろはa要素の後ろに合わせることにする
                    startPosition = cmStartPosition;
                    endPosition = writer.createPositionAfter(lastText);
                  } else if (cInfo.pattern == 9) {
                    // 途中から外まで　--->  この場合はマーカーの先頭はa要素の先頭に合わせることにする
                    startPosition = writer.createPositionBefore(firstText);
                    endPosition = cmEndPosition;
                  }

                  // コメントマーカーの更新
                  console.log('コメントマーカーを更新します。 コメントID：' + cInfo.cmKey);
                  const markerName = cInfo.cmKey;
                  const range = writer.createRange(startPosition, endPosition);
                  writer.updateMarker(markerName, { range });
                }
              }

              /*
              // リンク要素を削除
              for (const rmText of rmTexts) {
                writer.remove(rmText);
              }
              */
            }
          }
        }
      }
    });
  };

  // タグを遡ってaタグを含むpタグを取得
  static _getPAElement = (elementPa, taElemets) => {
    // pタグのモデル名
    const pModelNames = [
      'paragraphSupplementSubhead',
      'paragraphSupplementPara',
      'paragraphReferGear',
      'warningListTitle',
      'illustHeadline',
      'customGroup',
      'customItem',
      'paragraphRefer1',
      'paragraph',
    ];

    const cmMarkers = editor.model.markers;

    if (!elementPa) return;
    if (elementPa._children && elementPa._children._nodes.length > 0) {
      // 子要素あり
      elementPa._children._nodes.forEach((element) => {
        // Pタグのモデル名と一致するか確認
        if (pModelNames.indexOf(element.name) !== -1) {
          // pタグ内のリンク(modelではText)を検索し情報を取得
          // ※ 1対N の可能性もある
          const aInfoArr = this._getAInfo(element);
          if (aInfoArr.length > 0) {
            // リンクありの場合、情報を配列に入れる
            let item = {
              element: element, // Pタグ
              ainfo: aInfoArr, // Pタグ内のリンク情報配列
            };

            // 配列に格納
            taElemets.push(item);
          }
        }
        this._getPAElement(element, taElemets);
      });
      return;
    } else {
      // 子要素なし
      return;
    }
  };

  // コメント状態の取得
  static _hasComment = (path, stOff, enOff, cmMarkers) => {
    let pt = 0;
    let cmKey = true;

    let aStPath = path.map((v) => {
      return v;
    });
    let aEnPath = path.map((v) => {
      return v;
    });
    aStPath[aStPath.length - 1] = stOff; // a要素先端位置の配列
    aEnPath[aEnPath.length - 1] = enOff; // a要素後端位置の配列
    // console.log('該当Elementのパス：' + aStPath.toString() + ', ' + aEnPath.toString());

    const markersMap = editor.utils.toMap(cmMarkers._markers);
    // console.log('マーカー');
    // console.log(markersMap);
    for (const [key, val] of markersMap) {
      // コメントマーカー以外はスキップ（前方一致ではない時）
      if (key.indexOf('comment:')) {
        continue;
      }

      // console.log('++++++ comment +++++++');
      // console.log(key);
      // console.log(val.getRange());
      // console.log(val.getData());

      // マーカーキー(コメントスレッドID)
      cmKey = key;
      const cStPath = val.getStart().path; // コメント開始位置の配列
      const cEnPath = val.getEnd().path; // コメント終了位置の配列
      // console.log('コメントのパス：' + cStPath.toString() + ', ' + cEnPath.toString());

      if (aStPath.length != cStPath.length) {
        // 該当要素はコメントの範囲外
        // console.log('範囲外 pathの要素数が異なる');
      } else {
        // console.log('pathの要素数が一致');

        const cStASt = this._getPathArea(cStPath, aStPath);
        const cStAEn = this._getPathArea(cStPath, aEnPath);
        const cEnASt = this._getPathArea(cEnPath, aStPath);
        const cEnAEn = this._getPathArea(cEnPath, aEnPath);

        if (cStASt == 0 && cEnAEn == 0) {
          // 同じ
          //  ca         ac
          //  |[---------]|
          pt = 1;
          break;
        } else if (cStASt == 1 && cStAEn == -1 && cEnASt == 1 && cEnAEn == -1) {
          // 内側
          //  a      c         c      a
          //  [      |---------|      ]
          pt = 2;
          break;
        } else if (cStASt == -1 && cEnAEn == 1) {
          // 外から外
          //  c      a         a       c
          //  |------[---------]-------|
          pt = 3;
          break;
        } else if (cStASt == 0 && cEnAEn == 1) {
          // 前が同じ、後ろは外
          //  ca              a       c
          //  |[--------------]-------|
          pt = 4;
          break;
        } else if (cStASt == 0 && cEnASt == 1 && cEnAEn == -1) {
          // 前が同じ、後ろは中
          //  ca              c       a
          //  |[--------------|       ]
          pt = 5;
          break;
        } else if (cStASt == -1 && cEnAEn == 0) {
          // 後ろが同じ、前は外
          //  c      a         ac
          //  |------[---------]|
          pt = 6;
          break;
        } else if (cStASt == 1 && cStAEn == -1 && cEnAEn == 0) {
          // 後ろが同じ、前は中
          //  a      c         ac
          //  [      |---------]|
          pt = 7;
          break;
        } else if (cStASt == -1 && cEnASt == 1 && cEnAEn == -1) {
          // 前から途中まで
          //  c      a      c   a
          //  |------[------|   ]
          pt = 8;
          break;
        } else if (cStASt == 1 && cStAEn == -1 && cEnAEn == 1) {
          // 途中から外まで
          //  a    c          a       c
          //  [    |----------]-------|
          pt = 9;
          break;
        } else {
          // それ以外は範囲外
          //  c      c    a      a
          //  |------|    [      ]
          //  a      a    c      c
          //  [      ]    |------|
        }
      }
    }
    console.log('結果 : ' + cmKey + ' => ' + pt.toString());
    return { pattern: pt, cmKey: cmKey };
  };

  // コメントとa要素のpathの位置関係を取得
  static _getPathArea(cPath, aPath) {
    if (cPath.toString() == aPath.toString()) {
      // pathは同じ
      return 0;
    }

    const cnt = aPath.length;
    for (var i = 0; i < cnt; i++) {
      const cp = cPath[i];
      const ap = aPath[i];

      if (cp < ap) {
        // コメントのpathが前
        return -1;
      }

      if (cp > ap) {
        // コメントのpathが後
        return 1;
      }
    }
    // pathは同じ
    return 0;
  }

  // pタグ内にaタグが存在するか
  // aタグ内にインラインタグが存在する場合、複数に分かれてしまう。その場合は一つで良い
  static _getAInfo = (elementP) => {
    let arrA = [];
    let idArr = [];
    elementP._children._nodes.forEach((element) => {
      let isA = false;
      let href = '';
      let aId = '';
      let stPath = null;
      let enPath = null;

      // href属性値が存在する場合、リンク
      if (element.hasAttribute('linkHref')) {
        const linkHref = String(element.getAttribute('linkHref'));
        if (linkHref !== '') {
          if (linkHref.substring(0, 1) === '#') {
            isA = true;
            href = linkHref;
            stPath = element.getPath();
          }
        }
      }

      // id属性値
      if (element.hasAttribute('htmlA')) {
        const htmlA = element.getAttribute('htmlA');
        if (htmlA.attributes) {
          if (htmlA.attributes.id) {
            aId = htmlA.attributes.id;
          }
        }
      }

      // リンクID配列(重複無し)
      if (isA) {
        const find = idArr.find((i) => i == href);
        if (find == undefined) {
          idArr.push(href);
        }

        // pタグ内の全リンクデータ(異なるリンクIDが混在)
        let item = {
          reference_id: href,
          a_id: aId,
          path: stPath,
          st_off: parseInt(element.startOffset),
          en_off: parseInt(element.endOffset),
        };
        arrA.push(item);
      }
    });

    const retArr = idArr.map((href_id) => {
      // リンクIDでまとめた配列
      const filtered = arrA.filter((item) => item.reference_id === href_id);
      //console.log(filtered);

      // startOffsetの最小値取得
      const minOffset = Math.min(...filtered.map((item) => item.st_off));
      // endOffsetの最大値取得
      const maxOffset = Math.max(...filtered.map((item) => item.en_off));

      // コメントエリアが関係しているかの情報を取得
      const cmMarkers = editor.model.markers;
      const cmInfo = this._hasComment(filtered[0].path, minOffset, maxOffset, cmMarkers);

      // 配列にセット
      const retItem = {
        reference_id: href_id,
        a_id: filtered[0].a_id,
        c_info: cmInfo,
      };
      return retItem;
    });
    // console.log(retArr);

    return retArr;
  };

  // JavaScript（Fetch）を利用した非同期通信 (jQueryを利用してajaxで通信しない)
  static _getApiKey = () => {
    // Cookie から API キーを取得
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const trimmedCookie = cookie.trim();
      const pattern = new RegExp('^api-key=(.*)$');
      const match = trimmedCookie.match(pattern);
      if (match) {
        return match[1];
      }
    }
    return '';
  };
  static _getTopUrl = () => {
    return location.origin;
  };
  static _getApiTopUrl = (apiBasePath) => {
    const topUrl = this._getTopUrl();
    let apiTopUrl = apiBasePath;
    return new URL(apiTopUrl, topUrl).href;
  };

  // modelFragment ⇒ textモデルの配列に変換
  // <a href="X" id="Y">aaaaaa</a> ⇒ この場合、TEXTモデルは一つ
  // <a href="X" id="Y">aaa<sup>bbb</sup>ccc</a> ⇒ この場合、TEXTモデルは3つとなる。共通の属性値はhrefとid
  // Pタグ内に複数のAタグがある場合もあるので、識別子としてlinkHrefも戻り値に持つ
  static _getTextNode = (modelFragment) => {
    const texts = [];
    let href = '';
    const nodes = modelFragment._children._nodes;
    nodes[0]._children._nodes.forEach((text) => {
      texts.push(text);
      href = text.getAttribute('linkHref');
    });
    return { href: href, texts: texts };
  };
}

// リンクHrefの変更検知
class listenChangeLink {
  constructor(editor) {
    this.editor = editor;
  }
  init() {
    const editor = this.editor;

    // イベント
    // リンクボタンを押す、もしくは既存のリンクをクリックする ⇒ LinkFormViewが表示される。
    // ⇒ 保存ボタン(submit)を押す ⇒ ckeditor上でリンクが作成される ★この時点でのイベントを拾う
    editor.commands.get('link').on('execute', (evt, data) => {
      console.log('Link added');
      console.log(evt, data);
      console.log(data);
      refernceUpdater.onReferenceUpdateOnce(editor);
    });
  }
}

// ボツ(今後のためにイベントのコーディングだけ残す)
class customLinkFormView {
  constructor(editor) {
    this.editor = editor;
  }
  init() {
    const editor = this.editor;

    // リファレンス用の設定情報を取得
    const referenceConfig = editor.config.get('reference');
    const productionId = referenceConfig.productionId;
    const sectionId = referenceConfig.sectionId;
    const setApiProcessing = referenceConfig.setApiProcessing; // api処理中フラグ

    /**
     * イベント
     */
    let linkFormViewCustomized = false;
    editor.plugins.get('ContextualBalloon').on('change:visibleView', (evt, data, visibleView) => {
      if (!linkFormViewCustomized && visibleView && visibleView.element.classList.contains('ck-link-form')) {
        console.log(visibleView);
        // LinkFormView submit event
        visibleView.on(
          'submit',
          (evt, data) => {
            // 入力されたid
            const refernceId = String(visibleView.urlInputView.fieldView.element.value);
            if (refernceId === '') {
              // console.log('idなし');
            } else if (refernceId.substring(0, 1) === '#') {
              // カーソル位置
              const selection = editor.model.document.selection;
            }
          },
          { priority: 'high' }
        );
        linkFormViewCustomized = true;
      }

      // 以下はunlinkイベント(必要ならイベントに追加)
      let linkResponsiveFormViewCustomized = false;
      if (
        !linkResponsiveFormViewCustomized &&
        visibleView &&
        visibleView.element.classList.contains('ck-responsive-form')
      ) {
        visibleView.on(
          'unlink',
          (evt, data) => {
            // LinkFormView unlink event
          },
          { priority: 'high' }
        );
      }
    });
  }
}
